import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: '登录',
	component: () => import('@/views/login.vue')
}, {
	path: '/index',
	name: 'index',
	component: () => import('@/views/index.vue'),
	children: [{
			path: '/home',
			name: 'home',
			component: () => import('@/views/home.vue'),
			children: [{
					path: '/welcome',
					name: '欢迎',
					component: () => import('@/views/page/welcome.vue'),
				},{
					path: '/splb', //有
					name: '商品列表',
					component: () => import('@/views/page/store/splb.vue'),
				}, {
					path: '/yslb',
					name: '预售列表',
					component: () => import('@/views/page/store/yslb.vue'),
				}, {
					path: '/spAdd', //有
					name: '商品添加',
					component: () => import('@/views/page/store/spAdd.vue'),
				}, {
					path: '/mslb', //有
					name: '秒杀列表',
					component: () => import('@/views/page/store/mslb.vue'),
				}, {
					path: '/spfl', //有
					name: '商品分类',
					component: () => import('@/views/page/store/spfl.vue'),
				},
				// {
				//     path: '/twgl', //有
				//     name: '推文管理',
				//     component: () => import('@/views/page/twgl.vue'),
				// }, {
				//     path: '/twAdd', //有
				//     name: '推文添加',
				//     component: () => import('@/views/page/twAdd.vue'),
				// }, 
				{
					path: '/gift', //有
					name: '礼品管理',
					component: () => import('@/views/page/gift.vue'),
				}, {
					path: '/giftAdd', //有
					name: '新建礼品',
					component: () => import('@/views/page/giftAdd.vue'),
				},
				{
					path: '/yhgl', //有
					name: '用户管理',
					component: () => import('@/views/page/vipUser/yhgl.vue'),
				},
				{
					path: '/fhlb', //有
					name: '分红列表',
					component: () => import('@/views/page/vipUser/fhlb.vue'),
				}, {
					path: '/fhDet', //有
					name: '分红列表',
					component: () => import('@/views/page/vipUser/fhDet.vue'),
				},{
					path: '/cashout',
					name: '提现管理',
					component: () => import('@/views/page/vipUser/cashout.vue'),
				},
				{
					path: '/ddlb', //有
					name: '订单列表',
					component: () => import('@/views/page/order/ddlb.vue'),
				}, {
					path: '/ddlb2', //有
					name: '订单列表赠送',
					component: () => import('@/views/page/order/ddlb2.vue'),
				}, {
					path: '/ysdd',
					name: '预售订单',
					component: () => import('@/views/page/order/ysdd.vue'),
				}, {
					path: '/giftOrder',
					name: '礼品订单',
					component: () => import('@/views/page/order/giftOrder.vue'),
				}, {
					path: '/giftOrderDet',
					name: '礼品订单详情',
					component: () => import('@/views/page/order/giftOrderDet.vue'),
				}, {
                    path: '/receiveGift',
					name: '已领取礼品',
					component: () => import('@/views/page/order/receiveGift.vue')
                },{
					path: '/jfdd', //有
					name: '积分订单',
					component: () => import('@/views/page/jfdd.vue'),
				},
				// {
				//     path: '/yxsz',
				//     name: '营销设置',
				//     component: () => import('@/views/page/yxsz.vue'),
				// },
				{
					path: '/overview', //有
					name: '统计概况',
					component: () => import('@/views/page/overview.vue'),
				}, {
					path: '/personnel', //有
					name: '账号管理',
					component: () => import('@/views/page/personnel.vue'),
				}, {
					path: '/hygl',
					name: '业务管理',
					component: () => import('@/views/page/hygl.vue'),
				},
				// {
				//     path: '/tdfh', //有
				//     name: '团队分红',
				//     component: () => import('@/views/page/tdfh.vue'),
				// }, 
				// {
				//     path: '/gdfh', //有
				//     name: '股东分红',
				//     component: () => import('@/views/page/gdfh.vue'),
				// }, 
				{
					path: '/jfpz', //有
					name: '积分配制',
					component: () => import('@/views/page/integral/jfpz.vue'),
				}, {
					path: '/jfrz', //有
					name: '积分日志',
					component: () => import('@/views/page/integral/jfrz.vue'),
				},{
					path:'/jfPreview',
					name: '积分预览',
					component: () => import('@/views/page/integral/jfPreview.vue'),
				},{
					path: '/jfDet', //有
					name: '积分日志筛选',
					component: () => import('@/views/page/integral/jfDet.vue'),
				},{
					path: '/userIntegralDet', //有
					name: '使用积分详情',
					component: () => import('@/views/page/integral/userIntegralDet.vue'),
				}, {
					path: '/banner',
					name: '轮播管理',
					component: () => import('@/views/page/config/banner.vue'),
				}, {
					path: '/gggl',
					name: '公告管理',
					component: () => import('@/views/page/config/gggl.vue'),
				}, {
					path: '/kefu', //有
					name: '客服中心',
					component: () => import('@/views/page/config/kefu.vue'),
				}, {
					path: '/source',
					name: '溯源管理',
					component: () => import('@/views/page/source.vue'),
				}, {
					path: '/sourceAdd',
					name: '溯源详情',
					component: () => import('@/views/page/sourceAdd.vue'),
				}, {
					path: '/user',
					name: '用户管理',
					component: () => import('@/views/page/user.vue'),
				}, {
					path: '/conpou',
					name: '优惠券管理',
					component: () => import('@/views/page/conpou.vue'),
				}, {
					path: '/storeBack',
					name: '购买返商品管理',
					component: () => import('@/views/page/storeBack.vue'),
				}, {
					path: '/store',
					name: '赠送商品',
					component: () => import('@/views/page/store.vue'),
				}, {
					path: '/salesman',
					name: '销售人员',
					component: () => import('@/views/page/salesman.vue'),
				}, {
					path: '/label',
					name: '标签内容',
					component: () => import('@/views/page/tiyanUser/label.vue'),
				}, {
					path: '/experience',
					name: '体验用户',
					component: () => import('@/views/page/tiyanUser/experience.vue'),
				}, {
					path: '/evaluate',
					name: '评价管理',
					component: () => import('@/views/page/tiyanUser/evaluate.vue'),
				}, {
					path: '/fjsj',
					name: '附近商家',
					component: () => import('@/views/page/fjsj.vue'),
				}, {
					path: '/fjAdd',
					name: '添加附近商家',
					component: () => import('@/views/page/fjAdd.vue'),
				}, {
                    path: '/receivAddress',
					name: '收货地址',
					component: () => import('@/views/page/config/receivAddress.vue')
    
                },{
					path: '/examine',
					name: '审核管理',
					component: () => import('@/views/page/examine/examine.vue'),
					children: [{
						path: '/shareholder',
						name: '股东审核',
						component: () => import('@/views/page/examine/shareholder.vue'),
					}, {
						path: '/area',
						name: '区域代理审核',
						component: () => import('@/views/page/examine/area.vue'),
					}, {
						path: '/offlinePay',
						name: '线下支付审核',
						component: () => import('@/views/page/examine/offlinePay.vue'),
					}, {
						path: '/remind',
						name: '退款审核',
						component: () => import('@/views/page/examine/remind.vue'),
					}, {
						path: '/returnRefund',
						name: '退货退款审核',
						component: () => import('@/views/page/examine/returnRefund.vue'),
					}, {
						path: '/exchangeGoods',
						name: '换货审核',
						component: () => import('@/views/page/examine/exchangeGoods.vue'),
					}, {
                        path: '/refundDet',
						name: '审核详情',
						component: () => import('@/views/page/examine/refundDet.vue'),
                        
                    }]
				}
			]
		},

	]
},{
	path: '/setting',
	name: '后台',
	component: () => import('@/views/setting/index.vue'),
	children: [{
		path: '/setPersonnel',
		name: '人员管理',
		component: () => import('@/views/setting/personnel.vue'),
	},{
		path: '/setRole',
		name: '角色管理',
		component: () => import('@/views/setting/role.vue'),
	},{
		path: '/setJurisdiction',
		name: '权限管理',
		component: () => import('@/views/setting/jurisdiction.vue'),
	},{
		path: '/setNode',
		name: '节点管理',
		component: () => import('@/views/setting/nodeSet.vue'),
	}]
}]

const router = new VueRouter({
	routes
})
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router
